/**
 * 外車路由守衛：只要求 LIFF 已登入（要拿 LINE ID Token）。
 * 不用 components/ProtectedRoute——它會把未登入導回 /（會員入口），外車要停在自己的路徑上讓 LIFF 登入後回來。
 */
import React from 'react'
import { useLiff } from '@/contexts/LiffContext'
import { Box, Button, CircularProgress, Paper, Typography } from '@mui/material'
import LoginIcon from '@mui/icons-material/Login'

export const EXT_BG = 'linear-gradient(135deg, #FFE8D6 0%, #DDBEA9 100%)'
export const EXT_MAIN = '#6B705C'

export const ExtShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box sx={{ minHeight: '100vh', background: EXT_BG, px: 2, py: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <Box sx={{ width: '100%', maxWidth: 480 }}>{children}</Box>
  </Box>
)

export const ExtCenter: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box sx={{ minHeight: '100vh', background: EXT_BG, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, px: 3 }}>
    {children}
  </Box>
)

const ExtGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLoggedIn, loading, error, login } = useLiff()

  if (loading) {
    return (
      <ExtCenter>
        <CircularProgress size={56} sx={{ color: EXT_MAIN }} />
        <Typography variant="body1" color="text.secondary">正在連線 LINE…</Typography>
      </ExtCenter>
    )
  }
  if (error) {
    return (
      <ExtCenter>
        <Paper elevation={3} sx={{ p: 3, borderRadius: 3, textAlign: 'center', width: '100%', maxWidth: 400 }}>
          <Typography variant="h6" color="error" gutterBottom>無法初始化 LINE</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{error}</Typography>
          <Button fullWidth variant="outlined" onClick={() => window.location.reload()}>重新載入</Button>
        </Paper>
      </ExtCenter>
    )
  }
  if (!isLoggedIn) {
    return (
      <ExtCenter>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 3, textAlign: 'center', width: '100%', maxWidth: 400 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, color: EXT_MAIN, mb: 1 }}>好運網</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>同業司機接單，請先用 LINE 登入</Typography>
          <Button fullWidth variant="contained" size="large" startIcon={<LoginIcon />} onClick={() => login()}
            sx={{ backgroundColor: '#06C755', fontWeight: 600, py: 1.5, '&:hover': { backgroundColor: '#05B34B' } }}>
            使用 LINE 登入
          </Button>
        </Paper>
      </ExtCenter>
    )
  }
  return <>{children}</>
}

export default ExtGuard
